module.exports = __webpack_public_path__ + "static/media/pdf.03ba7a32.png";